import React from "react";
import { useSelector } from "react-redux";
import { IAppState } from "../../helpers/store";
import PlanData from "./PlanData";
import NoPlanData from "./NoPlanLayout";

export default function ViewSubscriptionForm() {
  /* ---- Hooks ---- */

  /* ---- Selectors ---- */
  const subscriptionData = useSelector(
    (state: IAppState) => state.dashboardState.subscriptionData
  );

  return (
    <React.Fragment>
      {subscriptionData.length > 0 &&
        subscriptionData.map((subscription, index) => {
          return (
            <PlanData
              key={index}
              subscriptionData={subscription}
              itemIndex={index + 1}
              primaryEmail={subscription.primary_email}
              isPrimaryUser={subscription.is_primary_user}
            />
          );
        })}
      {subscriptionData.length === 0 && <NoPlanData />}
    </React.Fragment>
  );
}
